<template>
  <v-navigation-drawer v-model="model" app>
    <v-list dense rounded>
      <v-list-item :to="{ name: $routes.admin.home.dashboardRoute.name }" exact>
        <v-list-item-icon>
          <font-awesome-icon icon="home"></font-awesome-icon>
        </v-list-item-icon>
        <v-list-item-title>
          Dashboard
        </v-list-item-title>
      </v-list-item>
      <v-list-group v-if="superuser">
        <template #prependIcon>
          <font-awesome-icon icon="poll"></font-awesome-icon>
        </template>
        <template v-slot:activator>
          <v-list-item-title>Sortitions</v-list-item-title>
        </template>
        <v-list-item
          :to="{ name: $routes.admin.sortition.createRoute.name }"
          exact
        >
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Create
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{ name: $routes.admin.sortition.indexRoute.name }"
          exact
        >
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Index
          </v-list-item-title>
        </v-list-item>
      </v-list-group>
      <v-list-group v-if="superuser">
        <template #prependIcon>
          <font-awesome-icon icon="poll"></font-awesome-icon>
        </template>
        <template v-slot:activator>
          <v-list-item-title>Sortitions For Results</v-list-item-title>
        </template>
        <v-list-item
          :to="{ name: $routes.admin.sortitionDisplay.createRoute.name }"
          exact
        >
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Create
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{ name: $routes.admin.sortitionDisplay.indexRoute.name }"
          exact
        >
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Index
          </v-list-item-title>
        </v-list-item>
      </v-list-group>
      <v-list-group v-if="superuser">
        <template #prependIcon>
          <font-awesome-icon icon="poll"></font-awesome-icon>
        </template>
        <template v-slot:activator>
          <v-list-item-title>Lotteries</v-list-item-title>
        </template>
        <v-list-item
          :to="{ name: $routes.admin.lottery.createRoute.name }"
          exact
        >
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Create
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{ name: $routes.admin.lottery.indexRoute.name }"
          exact
        >
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Index
          </v-list-item-title>
        </v-list-item>
      </v-list-group>
      <v-list-group v-if="superuser">
        <template #prependIcon>
          <font-awesome-icon icon="poll"></font-awesome-icon>
        </template>
        <template v-slot:activator>
          <v-list-item-title>Result API</v-list-item-title>
        </template>
        <v-list-item
            :to="{ name: $routes.admin.resultApiUser.createRoute.name }"
            exact
        >
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Create
          </v-list-item-title>
        </v-list-item>
        <v-list-item
            :to="{ name: $routes.admin.resultApiUser.indexRoute.name }"
            exact
        >
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Index
          </v-list-item-title>
        </v-list-item>
      </v-list-group>
      <v-list-item :to="{ name: $routes.admin.result.indexRoute.name }" exact>
        <v-list-item-icon>
          <font-awesome-icon icon="sticky-note"></font-awesome-icon>
        </v-list-item-icon>
        <v-list-item-title>
          Results
        </v-list-item-title>
      </v-list-item>
      <v-list-item :to="{ name: $routes.admin.profit.indexRoute.name }" exact>
        <v-list-item-icon>
          <font-awesome-icon icon="sticky-note"></font-awesome-icon>
        </v-list-item-icon>
        <v-list-item-title>
          Profits
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="superuser"
        :to="{ name: $routes.admin.prize.editRoute.name }"
        exact
      >
        <v-list-item-icon>
          <font-awesome-icon icon="dollar-sign"></font-awesome-icon>
        </v-list-item-icon>
        <v-list-item-title>
          Prizes
        </v-list-item-title>
      </v-list-item>
			<v-list-item
				v-if="superuser"
				:to="{ name: $routes.admin.actionLog.indexRoute.name }"
				exact
			>
				<v-list-item-icon>
					<font-awesome-icon icon="poo-storm"></font-awesome-icon>
				</v-list-item-icon>
				<v-list-item-title>
					Action Log
				</v-list-item-title>
			</v-list-item>
			<v-list-group v-if="superuser">
				<template #prependIcon>
					<font-awesome-icon icon="user"></font-awesome-icon>
				</template>
        <template v-slot:activator>
          <v-list-item-title>Users</v-list-item-title>
        </template>

        <v-list-item :to="{ name: $routes.admin.user.createRoute.name }" exact>
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Create
          </v-list-item-title>
        </v-list-item>
        <v-list-item :to="{ name: $routes.admin.user.indexRoute.name }" exact>
          <v-list-item-content></v-list-item-content>
          <v-list-item-title>
            Index
          </v-list-item-title>
        </v-list-item>
      </v-list-group>
      <v-list-item
        v-if="superuser"
        :to="{ name: $routes.admin.server.indexRoute.name }"
        exact
      >
        <v-list-item-icon>
          <font-awesome-icon icon="server"></font-awesome-icon>
        </v-list-item-icon>
        <v-list-item-title>
          Servers
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdministrationSidebar",
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters(["superuser"]),
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
::v-deep .v-list-item__icon {
  display: flex;
  align-items: center;
}
</style>
